(function () {
  'use strict';

  var CARD = '.hl-supplements-collection .thumbnail.hl-supplements-card';
  var FIXED_SIZE = '200px';
  var IMG_PX = 200;
  var locking = false;

  function inCard(node) {
    return node && node.closest && node.closest(CARD);
  }

  function lockWrap(wrap) {
    if (!wrap || wrap.dataset.hlGridImgLocked === '1') return;
    wrap.dataset.hlGridImgLocked = '1';
    wrap.classList.add('hl-grid-img-static');
    applyWrapStyles(wrap);
    observeWrap(wrap);
  }

  function applyWrapStyles(wrap) {
    locking = true;
    wrap.style.setProperty('max-width', FIXED_SIZE, 'important');
    wrap.style.setProperty('width', FIXED_SIZE, 'important');
    wrap.style.setProperty('height', FIXED_SIZE, 'important');
    wrap.style.setProperty('min-height', FIXED_SIZE, 'important');
    wrap.style.setProperty('background', '#fbf8f1', 'important');
    locking = false;
  }

  function observeWrap(wrap) {
    if (wrap.dataset.hlGridImgObserved === '1') return;
    wrap.dataset.hlGridImgObserved = '1';
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () {
      if (locking) return;
      var maxWidth = wrap.style.getPropertyValue('max-width');
      if (maxWidth && maxWidth !== FIXED_SIZE && maxWidth !== '200px') applyWrapStyles(wrap);
    });
    observer.observe(wrap, { attributes: true, attributeFilter: ['style'] });
  }

  function lockImg(img) {
    if (!img || img.dataset.hlGridImgLocked === '1') return;
    img.dataset.hlGridImgLocked = '1';
    img.setAttribute('data-sizes', FIXED_SIZE);
    img.style.setProperty('width', FIXED_SIZE, 'important');
    img.style.setProperty('height', FIXED_SIZE, 'important');
    img.style.setProperty('max-width', FIXED_SIZE, 'important');
    img.style.setProperty('max-height', FIXED_SIZE, 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
    img.style.setProperty('mix-blend-mode', 'multiply', 'important');
    img.style.setProperty('background', '#fbf8f1', 'important');
    var wrap = img.closest('.image-element__wrap');
    if (wrap) lockWrap(wrap);
  }

  function lockScope(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(CARD + ' .image-element__wrap').forEach(lockWrap);
    root.querySelectorAll(CARD + ' img').forEach(lockImg);
  }

  document.addEventListener(
    'lazybeforesizes',
    function (e) {
      if (!inCard(e.target)) return;
      e.detail.width = IMG_PX;
    },
    true
  );

  document.addEventListener('lazybeforeunveil', function (e) {
    if (!inCard(e.target)) return;
    lockImg(e.target);
  });

  document.addEventListener('lazyloaded', function (e) {
    if (!inCard(e.target)) return;
    lockImg(e.target);
  });

  window.hlLockApothecaryGridImages = lockScope;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lockScope(document);
    });
  } else {
    lockScope(document);
  }
})();
